export default __webpack_public_path__ + "static/media/heat.fd0baaeb.svg";